import { SharedModule } from 'src/app/shared/shared.module'

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'

import * as fromOperation from '../operation/operation.reducer'
import { OperationRoutingModule } from './operation-routing.module'
import { OperationEffects } from './operation.effects'
import { OperationSerializer } from './operation.serializer'
import { OperationService } from './operation.service'
import { OperationsGuard } from './operations.guard'
import { OperationShowModalComponent } from './show-modal/show.component'
import { OperationApproveOrganizationComponent } from './approve-organization/show.component'
import { OperationInternalEventModule } from './operation-internal-event/operation-internal-event.module'
import { SurveyModule } from '../survey/survey.module'
import { OperationApproveParticipationComponent } from './approve-participation/show.component'
import { OperationOrganizationExternalSyncConflictComponent } from './organization-external-sync-conflict/show.component'
import { OperationMemberExternalSyncConflictComponent } from './member-external-sync-conflict/show.component'
import { UserRoleModule } from '../role/user-role/user-role.module'
import { OperationApproveSalesComponent } from './approve-sale/show.component'
import { OperationApproveMemberComponent } from './approve-member/show.component'
import { MemberModule } from '../member/member.module'
import { OrganizationModule } from '../organization/organization.module'
import { ParticipationIdToSaleItemDateRangePipe } from './participation-id-to-sale-item-date-range.pipe'
import { OperationUpcomingSaleReminderOperationComponent } from './upcoming-sale-reminder-operation/show.component'
import { BookingCancelResolveOperationComponent } from './booking-cancel-resolve/show.component'
import { AdditonalSyncParamsOperationComponent } from './additional-sync-params/show.component'
import { DocumentModule } from '../document/document.module'
import { OperationApproveRentalComponent } from './approve-rental/show.component'
import { RentalModule } from '../rental/rental.module'
import { OperationSaleCancellationComponent } from './sale-cancellation/show.component'
import { OperationSupervisorEmployeeBookingCanceledComponent } from './supervisor-employee-booking-canceled/show.component'
import { OperationMessageNotificationComponent } from './message-notification/show.component'
import { OperationApproveChildAccountComponent } from './approve-child-account/show.component'
import { OperationMissingSkillComponent } from './missing-skill/show.component'

@NgModule({
  imports: [
    CommonModule,
    OperationRoutingModule,
    OperationInternalEventModule,
    UserRoleModule,
    SharedModule,
    StoreModule.forFeature(
      fromOperation.FEATURE_NAME,
      fromOperation.operationReducer
    ),
    EffectsModule.forFeature([OperationEffects]),
    MemberModule,
    DocumentModule,
    OrganizationModule,
    SurveyModule,
    RentalModule
  ],
  declarations: [
    OperationShowModalComponent,
    OperationSupervisorEmployeeBookingCanceledComponent,
    OperationApproveParticipationComponent,
    OperationApproveOrganizationComponent,
    OperationApproveMemberComponent,
    OperationOrganizationExternalSyncConflictComponent,
    OperationMemberExternalSyncConflictComponent,
    OperationApproveSalesComponent,
    ParticipationIdToSaleItemDateRangePipe,
    OperationUpcomingSaleReminderOperationComponent,
    BookingCancelResolveOperationComponent,
    AdditonalSyncParamsOperationComponent,
    OperationApproveRentalComponent,
    OperationSaleCancellationComponent,
    OperationMessageNotificationComponent,
    OperationApproveChildAccountComponent,
    OperationMissingSkillComponent
  ],
  exports: [OperationInternalEventModule],
  providers: [
    OperationService,
    {
      provide: OperationSerializer,
      useClass: OperationSerializer
    },
    OperationsGuard
  ]
})
export class OperationModule {}
